import styled from 'styled-components';
import { UnreachableCaseError } from 'ts-essentials';
import {
  ConversationThreadEntityType,
  IConversationEntityFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import ReportThreadHeading from './ReportThreadHeading';
import { overflowingStyles } from '../../../../styles/shareableStyles';

interface IProps {
  entity: IConversationEntityFieldsFragment;
}

const Container = styled.div`
  flex: 1;
  font-size: 12px;
  font-weight: 600;
  ${overflowingStyles};
`;

const ConversationThreadHeading = ({ entity }: IProps) => {
  switch (entity.type) {
    case ConversationThreadEntityType.Dashboard: {
      return <Container>Dashboard</Container>;
    }
    case ConversationThreadEntityType.Analysis: {
      return (
        <Container>
          <ReportThreadHeading entity={entity} />
        </Container>
      );
    }
    default:
      throw new UnreachableCaseError(entity.type);
  }
};

export default ConversationThreadHeading;
